import { routeMappings, apiUrls, SessionStore } from '../../constants';
import axios from '../../common/utils/interceptor';
import { SaveProcessDPNData } from '../../dpn/interfaces';
import { RegisterApiPayload } from '../interfaces/registerApi';
import { User } from '../../store/interfaces';
import { getStore } from '../../store';
import { getCookie } from './cookies';
import { WorkflowSession } from '../../store/interfaces/workflowSession';

interface RegisterResponse {
  status: number;
  message: string;
  customResponseCode: number | null;
}

const psuedoResponse: RegisterResponse = {
  status: 0,
  message: '',
  customResponseCode: null,
};

const registerApiSkipRoutes: string[] = [
  routeMappings['AUTH_LOGIN'],
  routeMappings['AUTH_WELCOME'],
  routeMappings['SSO'],
];

const skipRegisterApi = (): boolean => {
  return registerApiSkipRoutes.some((route) => window.location.href.includes(route));
};

export const registerAssessmentTCPlus = async (
  candidate: User,
  workflowSession: WorkflowSession,
  resetIndicator?: boolean,
): Promise<RegisterResponse> => {
  const companySettings = getStore()?.state?.companySettings;
  const isDPNEnabled = companySettings && companySettings.showDpn;
  const isAppFormEnabled = companySettings && companySettings.showAppform;
  const isCandidateRegistered = workflowSession && workflowSession.candidateRegistered;
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';

  if (!isCandidateRegistered) {
    if (tcPlusFlow && (skipRegisterApi() || resetIndicator) && isAppFormEnabled) {
      return psuedoResponse;
    } else {
      let dpnData: SaveProcessDPNData = {
        agreedForContact: false,
        dpnId: 0,
      };

      const appFormData = sessionStorage.getItem(SessionStore.applicationFormData);
      const appFormJSON = appFormData && JSON.parse(appFormData);
      if (isDPNEnabled) {
        const dpnSessionData = sessionStorage.getItem(SessionStore.dpnData);
        dpnData = dpnSessionData ? JSON.parse(dpnSessionData) : dpnData;
      }

      const dpnAccepted = companySettings?.showDpn?.toString();

      const authStream = sessionStorage.getItem(SessionStore.tcPlusAuthStream);

      const candidateEmail = candidate && candidate.email;
      const defaultFormData: { [key: string]: string } = {};
      defaultFormData['emailId'] = candidateEmail;

      let apiToken = '';
      let apiSecret = '';
      if (authStream != null) {
        apiSecret = JSON.parse(authStream).apiSecret;
        apiToken = JSON.parse(authStream).apiToken;
      }

      const payloadData: RegisterApiPayload = {
        dpnData: dpnData,
        appFormData: appFormJSON ? { ...appFormJSON, emailId: candidateEmail } : defaultFormData,
        dpnAccepted: dpnAccepted === 'true' ? 1 : 0,
        apiAuthToken: apiToken,
        apiSecret: apiSecret,
      };

      if (appFormData) payloadData.viaAppForm = true;
      try {
        const { status, data } = await axios.post(apiUrls.POST_ASSESSMENT_REGISTER, payloadData);
        data.status = status;
        return data;
      } catch (e) {
        const responseData: { status: number; message: string; customResponseCode: number | null } = {
          status: 200,
          message: '',
          customResponseCode: null,
        };
        responseData.status = e.status;
        if (e.status === 400) {
          responseData.message = e.data.message;
          responseData.customResponseCode = e.data.customResponseCode || null;
        } else {
          responseData.message = 'genericError';
        }
        return responseData;
      }
    }
  }

  return psuedoResponse;
};
